import getters from '@/nebula/getters';
import mutations from '@/nebula/mutations';
import { initState } from '@/nebula/initial-state';

export const initNebula = () => ({
  namespaced: true,
  state: initState(),
  mutations,
  getters,
});
